<template>
    <footer class="common-footer">
        <div class="common-footer__container">
            <div class="common-footer__wrapper">
                <a class="common-footer__logo"
                    href="/"
                    >
                    <svg width="234" height="35" viewBox="0 0 234 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M228.001 14.4456C231.088 14.4456 232.974 16.5281 232.974 19.8111C232.974 20.2031 232.925 20.6441 232.876 21.0851H225.036C225.379 22.8491 226.751 23.7801 228.515 23.7801C229.765 23.7801 230.647 23.4126 231.406 22.7511L232.533 24.4661C231.284 25.4706 229.961 25.9851 228.27 25.9851C224.767 25.9851 222.366 23.6086 222.366 20.1786C222.366 16.9691 224.693 14.4456 228.001 14.4456ZM227.952 16.6261C226.506 16.6261 225.355 17.5816 225.061 19.2721H230.451C230.377 17.5326 229.348 16.6261 227.952 16.6261Z" fill="#6737AF"/>
                        <path d="M218.218 25.9116C216.258 25.9116 214.959 24.7846 214.959 22.3346V17.0181L213.024 16.8711V14.7396H214.959L215.033 11.2361H217.63V14.7396H221.011V17.0181H217.63V22.0651C217.63 23.1431 218.12 23.4616 218.83 23.4616C219.467 23.4616 220.055 23.2901 220.668 22.8981L221.525 24.9071C220.521 25.5441 219.467 25.9116 218.218 25.9116Z" fill="#6737AF"/>
                        <path d="M206.788 14.5437C209.581 14.5437 211.296 15.9647 211.296 18.6107V25.6667H209.508L209.018 24.0252C208.209 25.1767 206.911 25.8872 205.122 25.8872C203.113 25.8872 201.692 24.7602 201.692 22.8247C201.692 20.3257 203.897 18.9537 207.229 18.9537C207.793 18.9537 208.209 18.9782 208.601 19.0027V18.5127C208.601 17.3857 207.768 16.8222 206.372 16.8222C205.294 16.8222 204.093 17.1652 202.966 17.7042L202.207 15.6707C203.824 14.9357 205.318 14.5437 206.788 14.5437ZM205.906 23.8782C207.474 23.8782 208.626 22.7267 208.675 20.7422C208.234 20.6932 207.891 20.6687 207.401 20.6687C205.465 20.6687 204.338 21.3547 204.338 22.5552C204.338 23.4127 204.926 23.8782 205.906 23.8782Z" fill="#6737AF"/>
                        <path d="M197.355 25.9116C195.395 25.9116 194.096 24.7846 194.096 22.3346V17.0181L192.161 16.8711V14.7396H194.096L194.17 11.2361H196.767V14.7396H200.148V17.0181H196.767V22.0651C196.767 23.1431 197.257 23.4616 197.967 23.4616C198.604 23.4616 199.192 23.2901 199.805 22.8981L200.662 24.9071C199.658 25.5441 198.604 25.9116 197.355 25.9116Z" fill="#6737AF"/>
                        <path d="M187.028 25.9116C185.411 25.9116 184.063 25.5196 182.789 24.7111L183.843 22.8246C184.774 23.4126 185.803 23.7311 186.832 23.7311C187.812 23.7311 188.449 23.2901 188.449 22.6041C188.449 21.7956 187.42 21.4036 186.342 20.9871C184.602 20.3256 183.255 19.4191 183.255 17.6306C183.255 15.6216 185.043 14.5681 187.126 14.5681C188.375 14.5681 189.527 14.8621 190.703 15.5481L189.772 17.3366C188.963 16.9201 188.081 16.6996 187.346 16.6996C186.513 16.6996 185.803 16.9446 185.803 17.6306C185.803 18.3411 186.611 18.7576 187.787 19.1741C189.698 19.8846 191.07 20.7911 191.07 22.6041C191.07 24.6376 189.429 25.9116 187.028 25.9116Z" fill="#6737AF"/>
                        <path d="M173.508 23.1186H181.324V25.6666H170.617V9.00659H181.103V11.5546H173.508V15.9646H180.148V18.4391H173.508V23.1186Z" fill="#6737AF"/>
                        <path d="M162.739 14.4456C165.826 14.4456 167.713 16.5281 167.713 19.8111C167.713 20.2031 167.664 20.6441 167.615 21.0851H159.775C160.118 22.8491 161.49 23.7801 163.254 23.7801C164.503 23.7801 165.385 23.4126 166.145 22.7511L167.272 24.4661C166.022 25.4706 164.699 25.9851 163.009 25.9851C159.505 25.9851 157.104 23.6086 157.104 20.1786C157.104 16.9691 159.432 14.4456 162.739 14.4456ZM162.69 16.6261C161.245 16.6261 160.093 17.5816 159.799 19.2721H165.189C165.116 17.5326 164.087 16.6261 162.69 16.6261Z" fill="white"/>
                        <path d="M151.952 25.6666V8.02661H154.622L154.647 25.6666H151.952Z" fill="white"/>
                        <path d="M144.228 14.4702C147.241 14.4702 149.446 16.8712 149.446 20.1542C149.446 23.5597 147.266 25.9362 144.228 25.9362C142.709 25.9362 141.435 25.3482 140.553 24.4172C140.602 25.1767 140.602 26.0587 140.602 27.0142V31.0567H137.931V14.7397H139.744L140.259 16.4057C141.165 15.2052 142.537 14.4702 144.228 14.4702ZM143.664 23.6087C145.502 23.6087 146.727 22.2122 146.727 20.2277C146.727 18.1942 145.502 16.8222 143.664 16.8222C141.778 16.8222 140.504 18.1697 140.504 20.1787C140.504 22.2367 141.802 23.6087 143.664 23.6087Z" fill="white"/>
                        <path d="M131.194 14.4456C133.595 14.4456 134.942 16.0626 134.942 18.6351V25.6666H132.272V18.9291C132.272 17.6061 131.586 16.8466 130.508 16.8466C128.817 16.8466 128.058 18.3411 128.058 19.8111V25.6666H125.412V18.9046C125.412 17.7776 124.824 16.8466 123.623 16.8466C121.957 16.8466 121.198 18.3411 121.198 19.8111V25.6666H118.527V14.7396H120.34L120.879 16.4791C121.614 15.1806 122.815 14.4456 124.358 14.4456C125.926 14.4456 127.078 15.1806 127.641 16.3811C128.352 15.2051 129.552 14.4456 131.194 14.4456Z" fill="white"/>
                        <path d="M114.062 12.4611C113.033 12.4611 112.396 11.7506 112.396 10.8686C112.396 9.98662 113.033 9.27612 114.062 9.27612C115.091 9.27612 115.728 9.98662 115.728 10.8931C115.728 11.7751 115.066 12.4611 114.062 12.4611ZM112.714 25.6666V14.7396H115.385V25.6666H112.714Z" fill="white"/>
                        <path d="M104.279 25.985C102.001 25.985 99.8202 25.25 98.1787 23.9515L99.5262 21.6975C100.776 22.7755 102.442 23.4125 104.181 23.4125C105.847 23.4125 107.293 22.653 107.293 21.183C107.293 19.615 105.578 18.9535 103.691 18.341C100.898 17.4345 98.7177 15.9155 98.7177 13.2695C98.7177 10.3295 101.266 8.68799 104.279 8.68799C106.215 8.68799 107.856 9.15349 109.694 10.3785L108.444 12.5345C107.023 11.628 105.798 11.236 104.426 11.236C102.956 11.236 101.658 11.873 101.658 13.1225C101.658 14.6415 103.348 15.2785 105.063 15.8665C107.954 16.7975 110.208 18.194 110.208 21.036C110.208 24.1475 107.587 25.985 104.279 25.985Z" fill="white"/>
                        <g clip-path="url(#clip0_12624_10400)">
                            <path d="M65.625 0H22.6043V15.3129H0V35H65.625V0Z" fill="#FF0508"/>
                            <path d="M5.06898 28.6307H6.21079C6.58474 28.6307 6.88732 28.4671 7.00721 28.1636L3.646 20.1193H5.84399L8.11191 26.3371H8.48514L10.726 20.12H12.8747L9.81678 27.5328C9.11885 29.2228 8.11191 30.3693 6.14657 30.3693H5.06969V28.6307H5.06898ZM44.1475 30.3636V20.1136H50.6423V21.9671H46.1828V30.3636H44.1475ZM22.8927 30.3636V28.3914H23.5257C24.4142 28.3914 24.7381 27.8964 24.7653 26.445L24.8844 20.1571V20.1086H32.0343V30.3586H30.0155V21.9671H26.7906L26.6985 26.3043C26.6286 29.1407 25.7401 30.3636 23.754 30.3636H22.8927ZM52.3693 15.2114V4.96141H54.3996V9.11355H58.4859V4.96141H60.5161V15.2114H58.4859V10.9671H54.3996V15.2114H52.3693ZM20.1809 26.8693L22.2112 27.1514C21.6973 29.3314 19.9925 30.6243 17.7738 30.6243C14.4782 30.6243 12.9404 28.2107 12.9404 25.2057C12.9404 22.2007 14.5753 19.8578 17.8708 19.8578C19.879 19.8578 21.4219 20.8414 22.1198 22.7428L20.1823 23.6128C19.7384 22.5586 18.9913 21.7378 17.7738 21.7378C15.7435 21.7378 15.0399 23.4007 15.0399 25.21C15.0399 27.0193 15.787 28.7536 17.8651 28.7536C19.1097 28.7428 19.8776 28.0143 20.1809 26.8678V26.8693ZM51.9754 30.3636V20.1136H54.005V28.5107H54.3782L56.6896 20.1136H60.5211V30.3636H58.4908V21.9671H58.1176L55.8497 30.3636H51.9747H51.9754ZM41.7447 15.2114V4.96141H43.7743V13.3578H44.1483L46.4597 4.96141H50.2648V15.2114H48.2345V6.79284H47.8613L45.6205 15.2114H41.7447ZM34.8981 28.6307H36.0399C36.4132 28.6307 36.7165 28.4671 36.8356 28.1636L33.4744 20.1193H35.6724L37.9404 26.3371H38.3143L40.5551 20.12H42.7039L39.6459 27.5321C38.9473 29.2221 37.9411 30.3686 35.9757 30.3686H34.8988V28.6307H34.8981ZM34.7575 13.1736L35.2228 13.1514C36.9762 13.0593 38.1188 11.7928 38.1188 10.0814C38.1188 8.36998 36.9762 7.17355 35.2228 7.0807L34.7575 7.05855V13.1728V13.1736ZM32.7979 15.8471V15.0057L32.3326 14.9836C29.3446 14.8421 27.4985 13.1086 27.4985 10.0814C27.4985 6.86927 29.3939 5.39141 32.3326 5.24998L32.7979 5.22784V4.37427H34.7625V5.21641L35.2285 5.23855C38.2429 5.37998 40.0884 6.80927 40.0884 10.07C40.0884 13.0978 38.2436 14.8314 35.2285 14.9721L34.7625 14.9943V15.8364H32.7979V15.8471ZM32.7979 7.04855L32.3326 7.0707C30.5571 7.16355 29.4581 8.26641 29.4581 10.0707C29.4581 11.875 30.535 13.0493 32.3326 13.1414L32.7979 13.1636V7.04927V7.04855Z" fill="white"/>
                        </g>
                        <g clip-path="url(#clip1_12624_10400)">
                            <path d="M85.9283 23.9773L75.2368 13.2859L76.8554 11.6673L87.5617 22.3439L85.9283 23.9773Z" fill="white"/>
                            <path d="M76.8701 23.9773L87.5615 13.2859L85.943 11.6673L75.2367 22.3439L76.8701 23.9773Z" fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_12624_10400">
                                <rect width="65.625" height="35" fill="white"/>
                            </clipPath>
                            <clipPath id="clip1_12624_10400">
                                <rect width="14" height="13.125" fill="white" transform="translate(74.375 11.375)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </a>
                <div class="common-footer__subscription">
                    <common-footer-subscription />
                </div>
                <div class="common-footer__info">
                    <common-footer-collapsable
                        title="Информация"
                        v-model="isInfoCollapsed"
                        >
                        <common-footer-info />
                    </common-footer-collapsable>
                </div>
                <div class="common-footer__contacts">
                    <common-footer-collapsable
                        title="Контакты"
                        v-model="isContactsCollapsed"
                        >
                        <common-footer-contacts />
                    </common-footer-collapsable>
                </div>
                <div class="common-footer__documents"
                    v-if="documents"
                    >
                    <common-footer-collapsable
                        title="Документы"
                        v-model="isDocumentsCollapsed"
                        >
                        <common-footer-documents v-bind:documents="documents" />
                    </common-footer-collapsable>
                </div>
                <div class="common-footer__copyright">
                    <p>
                        ООО «СИМПЛ ЭСТЭЙТ», ИНН 7707430579, ОГРН 1197746322289,
                        117342, г. Москва, ул. Бутлерова, д. 17, эт/комн 5/248
                    </p>
                    © {{ new Date().getFullYear() }} Все права защищены
                </div>
                <div class="common-footer__register">
                    <div class="common-footer__register-operator">
                        <a class="common-footer__register-icon"
                           v-bind:href="urls.bank"
                           target="_blank"
                        >
                            <icon name="bank-registry" width="31px" height="31px" original />
                        </a>
                        <div class="common-footer__register-text">
                            Платформа состоит в <a v-bind:href="urls.register" target="_blank">Реестре операторов инвестиционных платформ ЦБ&nbsp;РФ</a>
                        </div>
                    </div>
                    <div class="common-footer__register-text" style="opacity: 0.5;">
                        Предложение не является индивидуальной инвестиционной рекомендацией. Заключение с использованием инвестиционной платформы договоров, по которым привлекаются инвестиции, является высокорискованным и может привести к потере инвестированных денежных средств в полном объеме (пп. 2 п. 5.2. ст. 28 ФЗ "О&nbsp;рекламе").
                    </div>
                </div>
                <div class="common-footer__development">
                    Дизайн и разработка: <a class="common-footer__development-link"
                        v-bind:href="urls.initflow"
                        target="_blank"
                        >Initflow</a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import config from '~/config';

export default {
    name: 'common-footer-finuslugi',
    props: {
        documents: {
            type: Array,
            default: null,
        },
    },
    data: () => ({
        isInfoCollapsed: true,
        isContactsCollapsed: true,
        isDocumentsCollapsed: true,
    }),
    computed: {
        urls() {
            return {
                register: config.urls.footer.register,
                bank: config.urls.footer.bank,
                initflow: 'https://initflow.com',
            };
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.common-footer {
    .typography-body();

    color: @color-gray-light;

    background-color: #14161B;
    &__container {
        .container();
    }
    &__wrapper {
        display: grid;
        column-gap: @grid-gap;
        grid-template-columns: repeat(12, 1fr);
        padding-top: 52px;
        padding-bottom: 40px;
    }
    &__logo {
        .typography-medium();

        grid-row: 1;
        grid-column: ~'1 / 4';
        margin-bottom: 32px;

        text-decoration: none;
    }
    &__subscription {
        grid-row: ~'1 / 3';
        grid-column: ~'9 / 13';
    }
    &__info {
        grid-row: 2;
        grid-column: ~'1 / 4';
        margin-bottom: 28px;
    }
    &__contacts {
        grid-row: 2;
        grid-column: ~'4 / 6';
        margin-bottom: 28px;
    }
    &__documents {
        grid-row: 2;
        grid-column: ~'6 / 8';
        margin-bottom: 28px;
    }
    &__copyright {
        grid-row: 3;
        grid-column: ~'1 / 3';
        align-self: center;
    }
    &__register {
        grid-row: 3;
        grid-column: ~'4 / 9';
        align-self: center;
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: flex-start;
        gap: 12px;
        &-operator {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 12px;
            &-icon {
                flex: 0 0 auto;
                display: block;
                // margin-right: 12px;

                filter: grayscale(100%);
            }
            &-text {
                flex: 1 1 auto;
            }
        }
    }
    &__development {
        grid-row: 3;
        grid-column: ~'11 / 13';
        align-self: center;

        text-align: right;
        &-link {
            font-weight: 600;
            text-decoration: none;
            text-transform: uppercase;
            &:hover {
                text-decoration: underline;
            }
        }
    }
    @media @media-lg-down {
        &__documents {
            grid-row: 2;
            grid-column: ~'6 / 9';
        }
    }
    @media @media-md-down {
        &__wrapper {
            grid-template-columns: repeat(7, 1fr);
        }
        &__logo {
            grid-column: ~'1 / 8';
        }
        &__subscription {
            grid-row: ~'3 / 7';
            grid-column: ~'4 / 8';
        }
        &__info {
            grid-column: ~'1 / 4';
        }
        &__contacts {
            grid-column: ~'4 / 6';
        }
        &__documents {
            grid-column: ~'6 / 8';
        }
        &__copyright {
            grid-row: 5;
            grid-column: ~'1 / 4';
            align-self: flex-start;
            margin-bottom: 24px;
        }
        &__register {
            grid-row: 3;
            grid-column: ~'1 / 4';
            align-self: flex-start;
            margin-bottom: 24px;
        }
        &__development {
            grid-row: 6;
            grid-column: ~'1 / 4';
            align-self: flex-start;
            margin-bottom: 16px;

            text-align: left;
        }
    }
    @media @media-xs-down {
        &__wrapper {
            grid-template-columns: 1fr;
            justify-items: center;

            text-align: center;
        }
        &__logo {
            grid-column: 1;
        }
        &__subscription {
            grid-row: 2;
            grid-column: 1;
            margin-bottom: 24px;
        }
        &__info {
            grid-column: 1;
            grid-row: 3;
            margin-bottom: 24px;
        }
        &__contacts {
            grid-column: 1;
            grid-row: 4;
            margin-bottom: 24px;
        }
        &__documents {
            grid-column: 1;
            grid-row: 5;
            margin-bottom: 40px;
        }
        &__copyright {
            grid-column: 1;
            grid-row: 7;
            margin-bottom: 16px;
        }
        &__register {
            grid-column: 1;
            grid-row: 6;
            margin-bottom: 16px;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &-icon {
                margin-right: 0;
                margin-bottom: 8px;
            }
            &-operator {
                flex-direction: column;
                gap: 0;
            }
        }
        &__development {
            grid-column: 1;
            grid-row: 8;
            margin-bottom: 0;
        }
    }
}
</style>
